import { z } from 'zod';

import { ComponentValidator, ComponentPayloadValidator } from '../Component';

import { ComponentDefinition } from '../../types/ComponentDefinition';
import { AbstractPort, Port } from '../fields/AbstractPort';

const port = AbstractPort.extend({
    AC: Port.AC.default({}),
    DC: Port.DC.default({}),
}).default({
    powerFlowDirection: 'bidirectional',
});

const OtherBase = z.object({
    type: z.literal('other').default('other'),
    electrical: z.object({ ports: z.array(port).min(0).max(0).default([]) }).default({}),
});

export const OtherValidator = ComponentValidator.merge(OtherBase);
export const OtherPayloadValidator = ComponentPayloadValidator.merge(OtherBase);

export const OtherDefinition: ComponentDefinition = {
    type: 'other',
    name: 'Other',
    plural: 'Other',
    indicator: 'OTHER',
    hasDynamicNumberOfPorts: true,
    interoperabilityDataModel: false,
    description: 'Any other component that is not listed in the available components.',
    ports: {
        min: 0,
        max: 0,
        powerFlowDirections: ['input', 'output', 'bidirectional'],
    },
    liveData: {
        enabled: true,
        showGraphs: true,
    },
    validators: {
        component: OtherValidator,
        payload: OtherPayloadValidator,
    },
};

export type Other = z.infer<typeof OtherValidator>;
export type OtherPayload = z.infer<typeof OtherPayloadValidator>;
